import React from "react";

// v19-R1 R1: één kapot blok mag nooit de hele app wit maken. Het menu blijft bruikbaar.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fout: null };
  }

  static getDerivedStateFromError(fout) {
    return { fout };
  }

  componentDidCatch(fout, info) {
    console.warn("Pagina-fout opgevangen:", fout, info?.componentStack); // eslint-disable-line no-console
  }

  render() {
    if (!this.state.fout) return this.props.children;
    return (
      <div data-testid="pagina-fout" className="bg-white border border-zinc-200 rounded-[10px] px-5 py-6 max-w-xl">
        <p className="text-[15px] font-semibold text-zinc-900">Er ging iets mis op deze pagina.</p>
        <p className="text-sm text-zinc-500 mt-1">Je ingevoerde gegevens op andere pagina's zijn niet aangeraakt.</p>
        <button type="button" data-testid="pagina-fout-herladen" onClick={() => window.location.reload()}
          className="mt-4 px-4 py-2 rounded-md bg-zinc-950 text-white text-sm font-semibold hover:bg-zinc-800 transition-colors">Opnieuw laden</button>
      </div>
    );
  }
}
